import React from 'react';
import { Empresa, UserRole } from '../../types';

interface AdminHeaderProps {
  user: any;
  currentEmpresa: Empresa | null;
  view: string;
  isDemo?: boolean;
  onOpenSidebar: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({ user, currentEmpresa, view, isDemo = false, onOpenSidebar }) => {
  const getTitle = () => {
    switch(view) {
      case 'empresas': return 'Inquilinos';
      case 'pedidos': return 'Comandas';
      case 'produtos': return 'Cardápio';
      case 'categorias': return 'Categorias';
      case 'complementos': return 'Adicionais';
      case 'logistica': return 'Logística';
      case 'relatorios': return 'Insights';
      case 'configuracoes': return 'Ajustes';
      default: return 'Painel';
    }
  };

  return (
    <header className="h-20 px-4 md:px-10 bg-white border-b border-slate-200 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-3">
         <button onClick={onOpenSidebar} className="lg:hidden p-2 bg-slate-100 rounded-xl text-slate-900 active:scale-95 transition-transform">
           <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
         </button>
         <h2 className="text-lg md:text-xl font-black text-slate-900 tracking-tight">{getTitle()}</h2>
         {isDemo && (
           <div className="hidden sm:flex bg-orange-600 text-white px-3 py-1.5 rounded-full items-center gap-2 shadow-lg animate-pulse">
             <span className="text-[10px] font-black uppercase tracking-widest whitespace-nowrap">🔒 Modo demo</span>
           </div>
         )}
      </div>
      <div className="flex items-center gap-3 md:gap-6">
        <div className="hidden sm:flex items-center gap-2 bg-emerald-50 px-3 py-1.5 rounded-full border border-emerald-100">
           <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
           <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">Online</span>
        </div>
        <div className="hidden sm:block h-8 w-[1px] bg-slate-100"></div>
        <div className="flex items-center gap-3">
           <div className="text-right hidden sm:block">
              <p className="text-[11px] font-black text-slate-900 leading-none">{user?.nome}</p>
              <p className="text-[9px] font-bold text-slate-400 uppercase tracking-tighter mt-1 truncate max-w-[120px]">{user?.role === UserRole.SUPER_ADMIN ? 'SaaS Administrator' : currentEmpresa?.nome}</p>
           </div>
           <div className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center font-black text-slate-400 overflow-hidden shrink-0">
             {currentEmpresa?.logo_url ? <img src={currentEmpresa.logo_url} className="w-full h-full object-cover" /> : (user?.nome || 'A').charAt(0)}
           </div>
        </div>
      </div>
    </header>
  );
};